"use client";

import React, { useEffect, useState } from "react";
import { Dropdown, Button } from "antd";
import { MdKeyboardArrowDown } from "react-icons/md";
import "./FashionHeaderCountryDropdown.scss";
import fashionApi from "@/Apis/FashionApi";
import { useRouter } from "next/navigation";
import Cookies from "js-cookie";

const COUNTRIES = [
  { id: 23, name: "Pakistan", code: "PK", currency: "PKR" },
  { id: 1, name: "United States", code: "US", currency: "USD" },
  { id: 2, name: "United Kingdom", code: "GB", currency: "GBP" },
  { id: 3, name: "Canada", code: "CA", currency: "CAD" },
  { id: 4, name: "Australia", code: "AU", currency: "AUD" },
];

const FashionHeaderCountryDropdown = ({
  // selectedCountry = "Pakistan",
  onCountryChange = () => {},
}) => {
  const router = useRouter();
  const [countries, setCountries] = useState(COUNTRIES);
  const [isOpen, setIsOpen] = useState(false);

  const selectedCountry = Cookies.get("defaultCountry");

  const handleCountrySelect = (country) => {
    onCountryChange(country);
    setIsOpen(false);

    if (!country?.id || !country.currency) return;
    Cookies.set("defaultCurrencyName", country.currency);
    Cookies.set("defaultCurrencyId", country.id);
    Cookies.set("defaultCountry", country.name);
    router.refresh();
  };

  const menuItems = countries.map((country) => ({
    key: country.id,
    label: (
      <div className="fashion-header-country-dropdown__item">
        <span className="fashion-header-country-dropdown__item-name">
          {country.name}
        </span>
        <span className="fashion-header-country-dropdown__item-code">
          {country.code}
        </span>
      </div>
    ),
    onClick: () => handleCountrySelect(country),
  }));

  const handleGetStoreList = async () => {
    try {
      const result = await fashionApi.getStoreList();
      const availableStores = result?.data?.country_list;

      if (availableStores && availableStores.length > 0) {
        const options = availableStores.map((store) => ({
          id: store.id,
          name: store.country,
          code: store.short_code,
          currency: store.currency,
        }));

        setCountries(options);
      }
    } catch (error) {
      console.error("Failed fetching stores");
    }
  };

  useEffect(() => {
    handleGetStoreList();
  }, []);

  return (
    <div className="fashion-header-country-dropdown">
      <Dropdown
        menu={{ items: menuItems }}
        trigger={["click"]}
        open={isOpen}
        onOpenChange={setIsOpen}
        placement="bottomLeft"
      >
        <Button className="fashion-header-country-dropdown__button" type="text">
          <span className="fashion-header-country-dropdown__text">
            {selectedCountry}
          </span>
          <MdKeyboardArrowDown
            className={`fashion-header-country-dropdown__icon ${
              isOpen ? "fashion-header-country-dropdown__icon--open" : ""
            }`}
          />
        </Button>
      </Dropdown>
    </div>
  );
};

export default FashionHeaderCountryDropdown;
